import { render, staticRenderFns } from "./MarkdownEditorWidget.vue?vue&type=template&id=dca67aec&"
import script from "./MarkdownEditorWidget.vue?vue&type=script&lang=js&"
export * from "./MarkdownEditorWidget.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownEditorWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports